import { AccountStatus } from '@/swagger/constants/anagraphics-enums';

export const MOCK_RESPONSE_GET_EMPLOYEES_ME = {
  firstName: 'John',
  lastName: 'Doe',
  email: 'john.doe@example.com',
  manager: {
    employeeId: '123',
    email: 'manager@example.com',
  },
  role: 'Software Engineer',
  area: {
    id: '456',
    name: 'Engineering',
  },
  department: {
    id: '789',
    name: 'Development',
  },
  fiscalCode: 'ABC123',
  jobLevel: 'Mid',
  seniority: 'Senior',
  id: '101112',
  birthDate: '1990-01-01',
  isComplete: true,
  status: AccountStatus.ENABLED,
  createdAt: '2020-01-01',
  updatedAt: '2020-01-01',
  issues: [],
};
